import { ButtonHTMLAttributes, forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import styles from './Button.module.css';

export type ButtonVariant =
  | 'primary'
  | 'danger'
  | 'outline-success'
  | 'outline-danger'
  | 'outline-warning'
  | 'outline-info'
  | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

interface ButtonLinkProps extends LinkProps {
  variant?: ButtonVariant;
}

const variantMap: Record<ButtonVariant, string> = {
  primary: styles.btnPrimary,
  danger: styles.btnDanger,
  'outline-success': styles.btnOutlineSuccess,
  'outline-danger': styles.btnOutlineDanger,
  'outline-warning': styles.btnOutlineWarning,
  'outline-info': styles.btnOutlineInfo,
  ghost: styles.btnGhost,
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', className = '', children, ...rest }, ref) => {
    const variantClass = variantMap[variant] || '';
    return (
      <button
        ref={ref}
        className={`${styles.btn} ${variantClass}${className ? ` ${className}` : ''}`}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

export function ButtonLink({ variant = 'primary', className = '', children, ...rest }: ButtonLinkProps) {
  const variantClass = variantMap[variant] || '';
  return (
    <Link className={`${styles.btn} ${variantClass}${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </Link>
  );
}
